import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: undefined };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error: error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('Unhandled render error:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div
          className='d-flex flex-column align-items-center justify-content-center'
          style={{ height: '100vh' }}
        >
          <div className='card' style={{ maxWidth: '600px' }}>
            <div className='card-body'>
              <h4 className='card-title'>
                <i className='fa-solid fa-triangle-exclamation' /> Something
                went wrong
              </h4>
              <p className='card-text'>
                An unexpected error occurred while displaying this page.
              </p>
              {this.state.error !== undefined && (
                <pre
                  className='text-danger'
                  style={{ whiteSpace: 'pre-wrap', maxHeight: '150px', overflow: 'auto' }}
                >
                  {this.state.error.toString()}
                </pre>
              )}
              <button
                className='btn btn-primary'
                onClick={() => window.location.reload()}
              >
                <i className='fa-solid fa-redo' /> Reload
              </button>
            </div>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
